export const WIDGET_STORAGE_SCHEMA_VERSION = 1;
export const DEFAULT_WIDGET_PERSISTENCE_TTL_MS = 24 * 60 * 60 * 1000;
export const DEFAULT_WIDGET_MAX_TURNS = 20;

export type ResolvedWidgetPersistenceConfig = {
    enabled: boolean;
    restoreOnInit: boolean;
    ttlMs: number;
    maxTurns: number;
};

/**
 * Resolve the public persistence contract in one place so message history and
 * the n8n session cannot silently use different expiry policies.
 */
export function getWidgetPersistenceConfig(): ResolvedWidgetPersistenceConfig {
    let config: any = {};
    try {
        config = (globalThis as any).PublicWidgetConfig?.persistence || {};
    } catch {}

    return {
        enabled: config.enabled !== false,
        restoreOnInit: config.restoreOnInit !== false,
        ttlMs:
            typeof config.ttlMs === "number" && Number.isFinite(config.ttlMs) && config.ttlMs > 0
                ? Math.floor(config.ttlMs)
                : DEFAULT_WIDGET_PERSISTENCE_TTL_MS,
        maxTurns:
            typeof config.maxTurns === "number" && Number.isFinite(config.maxTurns) && config.maxTurns > 0
                ? Math.floor(config.maxTurns)
                : DEFAULT_WIDGET_MAX_TURNS
    };
}
